import { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchoolReportModulesUIHelpers";

const SchoolReportModulesUIContext = createContext();

export function useSchoolReportModulesUIContext() {
  return useContext(SchoolReportModulesUIContext);
}

export const SchoolReportModulesUIConsumer = SchoolReportModulesUIContext.Consumer;

export function SchoolReportModulesUIProvider({ term, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    term,
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <SchoolReportModulesUIContext.Provider value={value}>
      {children}
    </SchoolReportModulesUIContext.Provider>
  );
}